import { Navigate, type RouteObject } from 'react-router-dom';

import { AccountAuthenticatedLayout } from './AccountAuthenticatedLayout';
import { AccountPublicOnlyLayout } from './AccountPublicOnlyLayout';
import { AccountRootLayout } from './AccountRootLayout';

export const accountRoutes: RouteObject = {
  path: 'account',
  element: <AccountRootLayout />,
  children: [
    { index: true, element: <Navigate to="interviews" replace /> },
    {
      path: 'login',
      element: <AccountPublicOnlyLayout />,
      lazy: () => import('../../app/account/login/page'),
    },
    {
      path: '',
      element: <AccountAuthenticatedLayout />,
      children: [
        {
          path: 'personal-info',
          lazy: () => import('../../app/account/settings/personal-info/page'),
        },
        {
          path: 'interviews',
          lazy: () => import('../../app/account/settings/interviews/page'),
        },
        {
          path: 'cv-analysis',
          lazy: () => import('../../app/account/settings/cv-analysis/page'),
        },
      ],
    },
  ],
};
